module.exports = __webpack_public_path__ + "img/1.dec327a1.png";